import React from "react";
import PlusBadge from "../Header/AlertBanner/Logos/PlusBadge";
import connectUserAndChat, { User } from "../Store/connectUserAndChat";

const FooterCTA = ({ user }: { user: User }) => {
  const sharedBorderStyles = "border-gray-300 border-solid";

  return (
    <div className="!flex flex-col w-full relative lg:w-[567px] xl:w-[615px] xxxl:w-[748px] md:justify-center md:w-full">
      <hr
        className={`hidden md:block lg:hidden border-0 border-t -inset-x-14 absolute top-0 m-0 ${sharedBorderStyles}`}
      />
      <div className="!flex flex-col md:flex-row md:justify-center">
        <div
          className={`lg:min-w-[283px] !flex gap-3 items-center md:justify-center px-4 md:px-9 lg:px-4 xl:px-8 xxxl:px-20 py-5 border-0 border-b md:border-0 ${sharedBorderStyles}`}
        >
          <PlusBadge classNames="w-12 h-6" />
          {user.hasWebPlus ? (
            <>
              <div>
                <p className="font-semibold text-sm leading-snug my-0 text-gray-800 whitespace-nowrap">
                  Switch and Save
                </p>
                <p className="text-xs leading-snug my-0 text-gray-800 lg:max-w-[175px] xxl:max-w-[230px]">
                  Save even more when you shop essentials with Plus.
                </p>
                <a
                  className="mb-2 text-sm font-semibold text-green-700 hover:text-green-900 underline hover:no-underline"
                  href="/feature/28188/switch-and-save/"
                >
                  Shop Essentials
                </a>
              </div>
            </>
          ) : (
            <>
              <div>
                <p className="font-semibold text-sm leading-snug my-0 text-gray-800 whitespace-nowrap">
                  Unlock Savings with FREE Shipping
                </p>
                <p className="text-xs leading-snug my-0 text-gray-800">
                  No commitment, cancel at anytime.
                </p>
                <a
                  className="mb-2 text-sm font-semibold text-green-700 hover:text-green-900 underline hover:no-underline"
                  href="/plus/"
                >
                  Start saving with Plus
                </a>
              </div>
            </>
          )}
        </div>
        <div
          className={`hidden md:block border-0 border-l h-[139px] xl:h-[119px] ${sharedBorderStyles}`}
        />
        <div
          className={`lg:min-w-[225px] !flex gap-3 items-center px-4 md:px-9 lg:px-4 lg:pr-0 xl:px-8 xl:pr-0 xxxl:px-20 xxxl:pr-0 py-5 border-0 border-b md:border-0 ${sharedBorderStyles}`}
        >
          <svg
            aria-hidden="true"
            width="48"
            height="45"
            viewBox="0 0 48 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="9"
              y="4"
              width="22.5"
              height="39.5"
              rx="5"
              fill="#A6D690"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 5.75C12 3.12646 14.1266 1 16.75 1H29.75C32.3733 1 34.5 3.12646 34.5 5.75V9.75C34.5 10.1641 34.1642 10.5 33.75 10.5C33.3358 10.5 33 10.1641 33 9.75V5.75C33 3.95508 31.5449 2.5 29.75 2.5H16.75C14.9551 2.5 13.5 3.95508 13.5 5.75V35.75C13.5 37.5449 14.9551 39 16.75 39H29.75C31.5449 39 33 37.5449 33 35.75V32.25C33 31.8359 33.3358 31.5 33.75 31.5C34.1642 31.5 34.5 31.8359 34.5 32.25V35.75C34.5 38.3735 32.3733 40.5 29.75 40.5H16.75C14.1266 40.5 12 38.3735 12 35.75V5.75ZM20 7.25C20 6.83594 20.3358 6.5 20.75 6.5H26.25C26.6642 6.5 27 6.83594 27 7.25C27 7.66406 26.6642 8 26.25 8H20.75C20.3358 8 20 7.66406 20 7.25ZM23.25 36.75C24.0784 36.75 24.75 36.0786 24.75 35.25C24.75 34.4214 24.0784 33.75 23.25 33.75C22.4216 33.75 21.75 34.4214 21.75 35.25C21.75 36.0786 22.4216 36.75 23.25 36.75Z"
              fill="#1D5C00"
            />
            <path
              d="M22.75 13.9916L22.75 19.7249L23.9867 11.9932C23.6145 12.1802 23.3019 12.466 23.0836 12.8188C22.8652 13.1716 22.7498 13.5775 22.75 13.9916Z"
              fill="#1D5C00"
            />
            <path
              d="M32.6948 13.6233L35.3976 14.874L33.4836 24.9937L39.7496 16.9381L39.7496 13.9913C39.7496 13.3969 39.5117 12.8268 39.0881 12.4065C38.6646 11.9861 38.0901 11.75 37.4911 11.75L28.2585 11.75L26.1143 21.5836L32.6948 13.6233Z"
              fill="#1D5C00"
            />
            <path
              d="M35.0977 28.6209L37.4913 28.6209C38.0902 28.6209 38.6647 28.3848 39.0883 27.9644C39.5118 27.5441 39.7498 26.974 39.7498 26.3796L39.7498 23.3096L35.0977 28.6209Z"
              fill="#1D5C00"
            />
            <path
              d="M25.6123 26.8419L22.75 25.5165L22.75 26.3785C22.75 26.9729 22.9879 27.543 23.4115 27.9634C23.8351 28.3837 24.4095 28.6198 25.0085 28.6198L29.7749 28.6198L31.6698 19.3081L25.6123 26.8419Z"
              fill="#1D5C00"
            />
            <path
              d="M39.75 16.9381L33.484 24.9937L35.398 14.874L32.6952 13.6233L26.1146 21.5836L28.2589 11.75L25.0085 11.75C24.6533 11.7497 24.3032 11.833 23.9867 11.9929L22.75 19.7247L22.75 25.5165L25.6123 26.8409L31.6698 19.3081L29.7749 28.6207L35.0979 28.6207L39.7482 23.312L39.75 16.9381Z"
              fill="white"
            />
          </svg>
          <div>
            <p className="font-semibold text-sm leading-snug my-0 text-gray-800 whitespace-nowrap">
              WebstaurantStore App
            </p>
            <p className="text-xs leading-snug my-0 text-gray-800">
              It&#39;s faster & easier in the app.
            </p>
            <a
              className="mb-2 text-sm font-semibold text-green-700 hover:text-green-900 underline hover:no-underline"
              href="/services/app/"
            >
              Learn more about our App
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connectUserAndChat(FooterCTA);
